export const QUERY_KEY = {
  FETCH_BANNER_LIST: 'fetchBannerList',
  FETCH_LIVE_LIST: 'fetchLiveList',
  FETCH_MEMBER_DATA: 'fetchMemberData',
  FETCH_ROOM_LIVING_DATA: 'fetchRoomLivingData',
  FETCH_ROOM_DATA: 'fetchRoomData',
  FETCH_PRODUCT_DATA: 'fetchProductData',
  FETCH_PRODUCT_LIST: 'fetchProductList',
  FETCH_PRODUCT_RECOMMEND: 'fetchProductRecommend',
  FETCH_CATEGORY_PREFERENCE: 'fetchCategoryPreference',
  FETCH_CATEGORY_LIST: 'fetchCategoryList',
  FETCH_CATEGORY_MENU: 'fetchCategoryMenu',
  FETCH_SITE_NAV: 'fetchSiteNav',
  FETCH_LIVE_INFO: 'fetchLiveInfo',
  FETCH_PLAYBACK_INFO: 'fetchPlaybackInfo',
  FETCH_CATEGORY_FILTER: 'fetchCategoryFilter',
  FETCH_USER_AUTH: 'fetchUserAuth',
  FETCH_REFRESH_TOKEN: 'fetchRefreshToken',
  FETCH_ROOM_PRODUCT_DATA: 'fetchRoomProductData',
  FETCH_AUCTION_LOTS: 'fetchAuctionLots',
  FETCH_AUCTION_LOTS_VERSION: 'fetchAuctionLotsVersion',
  FETCH_AUCTION_LOT_DETAIL: 'fetchAuctionLotDetail',
  FETCH_ROOM_SALE_INFO: 'fetchRoomSaleInfo',
  FETCH_LIVE_MEMBER_ROLE: 'fetchLiveMemberRole',
  FETCH_MERCHANT_INFO: 'fetchMerchantInfo',
  FETCH_CART_ID: 'fetchCartId',
  FETCH_CART_DATA: 'fetchCartData',
  UPDATE_CART_DATA: 'updateCartData',
  FETCH_PRECART_LIST: 'fetchPreCartList',
  FETCH_MERCHANTS_INFO: 'fetchMerchantsInfo',
  FETCH_USER_PROFILE: 'fetchUserProfile',
  FETCH_REGION_DATA: 'fetchRegionData',
  FETCH_PAYMENT_METHOD: 'fetchPaymentMethod',
  FETCH_DELIVERY_METHOD_LIST: 'fetchDeliveryMethodList',
  FETCH_CREATE_ORDER: 'fetchCreateOrder',
  FETCH_MEMBER_LIVE_LIST: 'fetchMemberLiveList',
  FETCH_CURRENT_LIVE_LIST: 'fetchCurrentLiveList',
  FETCH_FUTURE_LIVE_LIST: 'fetchFutureLiveList',
  FETCH_PAST_LIVE_LIST: 'fetchPastLiveList',
  REMOVE_ROOM_PRODUCT_DATA: 'removeRoomProductData',
  FETCH_ORDER_PRE_CART_AMOUNT: 'fetchOrderPreCartAmount',
  UPDATE_MEMBER_DATA: 'updateMemberData',
  FETCH_ORDER_LIST: 'fetchOrderList',
  FETCH_ORDER_DATA: 'fetchOrderData',
  FETCH_CHECKING_ORDER_LIST: 'fetchCheckingOrderList',
  FETCH_CHECKING_ORDER_DATA: 'fetchCheckingOrderData',
  FETCH_RETURNED_ORDER_LIST: 'fetchReturnedOrderList',
  FETCH_RETURNED_ORDER_DATA: 'fetchReturnedOrderData',
  FETCH_EXTRA_MEMBER_DATA: 'fetchExtraMemberData',
  DELETE_ORDER: 'deleteOrder',
  FETCH_DONATION_INVOICE_LIST: 'fetchDonationInvoiceList',
  FETCH_PROMOTION_TICKET_LIST: 'fetchPromotionTicketList',
  SET_PROMOTION_TICKET: 'setPromotionTicket',
  FETCH_PROMOTION_PRICE_RANGE: 'fetchPromotionPriceRange',
  FETCH_THEME_PRODUCT_LIST: 'fetchThemeProductList',
  FETCH_THEME_LIST: 'fetchThemeList',
  FETCH_SEARCH_DATA: 'fetchSearchData',
  FETCH_SEARCH_HOT_KEY: 'fetchSearchHotKey',
  FETCH_SEARCH_HOT_KEY_LIVE: 'fetchSearchHotKeyLive',
  FETCH_LIVE_ROOM_LIST_BY_PRODUCT_ID: 'fetchLiveRoomListByProductId',
  FETCH_INVOICE_DATA: 'fetchInvoiceData',
  FETCH_RECENT_LIVE_STREAMING_PRODUCT_LIST: 'fetchRecentLiveStreamingProductList',
  FETCH_PRODUCT_LIVE_DATE: 'fetchProductLiveDate',
  FETCH_PLATFORM_ANNOUCEMENTS: 'fetchPlatformAnnouncements',
  FETCH_STRAWBERRY_TOKEN: 'fetchStrawberryToken',
  FETCH_CATEGORY_PRODUCT_LIVE_TIME: 'fetchCategoryProductLiveTime',
  FETCH_BANK_INFO_DATA: 'fetchBankInfoData',
  FETCH_RECOMMEND_MERCHANTS: 'fetchRecommendMerchants',
  FETCH_PCHOME_PRODUCT_DATA: 'fetchPchomeProductData',
  FETCH_PCHOME_TOKEN: 'fetchPchomeToken',
  FETCH_POPULAR_PRODUCTS: 'fetchPopularProducts',
  FETCH_POPULAR_PRODUCTS_FROM_MALL: 'fetchPopularProductsFromMall',
  FETCH_PLATFORM_SETTING: 'fetchPlatformSetting',
  FETCH_EVENT_NAME: 'fetchEventName',
  FETCH_EXPLORE_FEED: 'fetchExploreFeed',
  FETCH_FOLLOW_FEED: 'fetchFollowFeed',
  FETCH_EXPLORE_VENDOR_BLOCK: 'fetchExploreVendorBlock',
  FETCH_FOLLOW_VENDOR_BLOCK: 'fetchFollowVendorBlock',
  FETCH_ALL_PREFERENCES: 'fetchAllPreferences',
  FETCH_MEMBER_PREFERENCES: 'fetchMemberPreferences',
  FETCH_FOLLOWERS: 'fetchFollowers',
  FETCH_FOLLOWING_MEMBERS: 'fetchFollowingMembers',
  FETCH_MEMBER_ROLE_INFO: 'fetchMemberRoleInfo',
  FETCH_LIVE_MALL_SEARCH: 'fetchLiveMallSearch',
  FETCH_VENDOR_FOLLOW_SUGGESTS: 'fetchFollowVendorSuggestion',
  FETCH_IS_MEMBER_FOLLOWED: 'fetchIsMemberFollowed',
  FETCH_ROOM_INVITED_KOL: 'fetchRoomInvitedKol',
  FETCH_MEMBER_TIMELINE_LIVES: 'fetchMemberTimelineLives',
  FETCH_MEMBER_TIMELINE_PRODUCTS: 'fetchMemberTimelineProducts',
  FETCH_VIP_FOLLOWERS: 'fetchVipFollowers',
  FETCH_MEMBER_VIPS: 'fetchMemberVips',
  FETCH_ROOM_CAN_ACCESS: 'fetchRoomCanAccess',
  FETCH_KOL_APPLY_STATUS: 'fetchKolApplyStatus',
  FETCH_MERCHANT_APPLY_STATUS: 'fetchMerchantApplyStatus',
  FETCH_ADDRESS_BY_POSTAL_CODE: 'fetchAddressByPostalCode',
  FETCH_RESET_PASSWORD: 'fetchResetPassword',
  FETCH_SEND_RESET_PASSWORD_MAIL: 'fetchSendResetPasswordMail',
  FETCH_LIVE_MALL_BANKS: 'fetchLiveMallBanks',
  FETCH_APPLICATIONS: 'fetchApplications',
  FETCH_ACCOUNT_BINDINGS: 'fetchAccountBindings',
  FETCH_PROMO_CATEGORY_LIST: 'fetchPromoCategoryList',
  FETCH_MULTI_DROPDOWN_VALUE: 'fetchMultiDropdownValue',
  FETCH_MERCHANT_RETURN_POLICY: 'fetchMerchantReturnPolicy',
  FETCH_MERCHANT_POLICIES: 'fetchMerchantPolicies',
  FETCH_NOTIFICATION_LIST: 'fetchNotificationList',
  FETCH_FREE_SHIPPING_INFO: 'fetchFreeShippingInfo',
  FETCH_COUNTRY_DATA_BY_ALL: 'fetchCountryDataByAll',
  FETCH_V2_ACCOUNT_TYPE: 'fetchV2AccountType',
  FETCH_V2_MEMBER_PROFILE: 'fetchV2MemberProfile',
  FETCH_PAYMENT_CARDS: 'fetchPaymentCards',
}
